import React from 'react'

const UserRoleSelectV3 = ({ roles, role, setRole, disabled = false, }) => {

    const handleTypeToggle = (val) => {
        if (disabled) return;
        
        if (role[0] !== val) {
            setRole([val]);
        }
    };
    return (
        <div style={{display: "flex", flexWrap: "wrap", }}>
            {roles?.map((item) => {
                const isSelected = role?.includes(item?.value) ||
                    (item?.value === "Operation" && role?.some(r => String(r || "").toLowerCase().includes("operation")));
                return (
                    <div
                        key={item.value}
                        className='sortByFilter'
                        style={{
                            backgroundColor: isSelected ? "#D6C8F5" : '#FFFFFF',
                            color: isSelected ? '#191919' : "#636363",
                            border: isSelected ? 'none' : '1px solid #E6E6E6',
                            maxWidth: 130,
                            minWidth: 100,
                            alignItems: 'center',
                        }}
                        onClick={() => handleTypeToggle(item?.value)}
                    >
                        {item?.label}
                    </div>
                );
            })}
        </div>
    )
}

export default UserRoleSelectV3